import { ScrollLock } from './../../utils/scroll-lock';
import { FocusLock } from './../../utils/focus-lock';

export class Burger {
  constructor(headerClass, burgerClass, overlayClass) {
    this._headerClass = headerClass;
    this._burgerClass = burgerClass;
    this._overlayClass = overlayClass;
    this._header = document.querySelector(this._headerClass);
    this._burger = document.querySelector(this._burgerClass);
    this._scrollLock = new ScrollLock();
    this._focusLock = new FocusLock();
    this._isMenuOpen = false;

    this._onBurgerClick = this._onBurgerClick.bind(this);
    this._onDocumentKeydown = this._onDocumentKeydown.bind(this);
    this._onDocumentClick = this._onDocumentClick.bind(this);
  }

  init() {
    if (!this._burger) {
      return;
    }

    this._burger.addEventListener('click', this._onBurgerClick);
  }

  _openMenu() {
    this._isMenuOpen = true;
    this._header.classList.add('is-open');
    if (this._overlayClass) {
      this._overlayClass.classList.add('is-active');
    }
    this._scrollLock.disableScrolling();
    document.addEventListener('keydown', this._onDocumentKeydown);
    document.addEventListener('click', this._onDocumentClick);
    this._focusLock.lock(this._headerClass);
    if (window.ls) {
      window.ls.stop();
    }
  }

  _closeMenu() {
    this._isMenuOpen = false;
    if (this._header) {
      this._header.classList.remove('is-open');
    }
    if (this._overlayClass) {
      this._overlayClass.classList.remove('is-active');
    }
    this._scrollLock.enableScrolling();
    this._focusLock.unlock(this._headerClass);
    document.removeEventListener('keydown', this._onDocumentKeydown);
    document.removeEventListener('click', this._onDocumentClick);
    if (window.ls) {
      window.ls.start();
    }
  }

  _onBurgerClick() {
    if (this._isMenuOpen) {
      this._closeMenu();
    } else {
      this._openMenu();
    }
  }

  _onDocumentKeydown(evt) {
    if (evt.key === 'Escape') {
      this._closeMenu();
    }
  }

  _onDocumentClick(evt) {
    if (evt.target.hasAttribute('data-close-menu')) {
      this._closeMenu();
      this._burger.blur();
    }

    if (evt.target.closest('[data-menu-link]')) {
      const link = evt.target.closest('[data-menu-link]');

      evt.preventDefault();
      const id = link.getAttribute('href');

      this._closeMenu();
      document.querySelector(id).scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  }

  setHeight() {
    const headerRect = this._header.getBoundingClientRect();
    document.documentElement.style.setProperty('--header-height', headerRect.height + 'px');
  }
}
